import { useState } from "react";
import firebase from "firebase";
import "firebase/storage";
import "firebase/firestore";

import { snap } from "gsap/gsap-core";

const Beatscont = (props) => {
  const myPhone = localStorage.getItem("user-phone");
  const firestore = firebase.firestore();
  const storage = firebase.storage();
  const [audio, setAudio] = useState([]);
  const [playing, setPlaying] = useState("");
  var likeColor = "lavender";

  if (props.likes.indexOf(myPhone) !== -1) {
    likeColor = "tomato";
  }

  function checkAudioPlaying(id) {
    var playing = localStorage.getItem("audio-playing");
    console.log(id);
    if (playing !== null) {
      const currentlyPlaying = document.getElementById(playing);

      if (id !== playing && currentlyPlaying !== null) {
        currentlyPlaying.pause();
        currentlyPlaying.parentElement.parentElement.children[0].children[1].style.color =
          "grey";
        localStorage.setItem("audio-playing", id);
      } else {
        localStorage.setItem("audio-playing", id);
      }
    } else {
      localStorage.setItem("audio-playing", id);
    }
  }

  return (
    <div className="beats-cont flex-col-evenly">
      <div className="beats-header ">
        <div className="beats-user-info flex-start">
          <img src={props.dp} />
          {props.name}
        </div>
        <p className="beats-name">{props.audioName}</p>
      </div>
      <div className="beats-img">
        <div
          onClick={(e) => {
            const tag = e.target;
            const container = tag.parentElement.parentElement;
            const header = tag.parentElement.previousElementSibling.children[1];
            const img = tag.nextElementSibling;
            const audio = e.target.parentElement.nextElementSibling.children[0];

            if (audio.paused) {
              audio.play();
              header.style.color = "coral";
            } else {
              audio.pause();
              container.style.border = "";
              header.style.color = "";
            }

            checkAudioPlaying(audio.id);
          }}
          className="audio-progress"
        >
          <div className="progress-bar"></div>
        </div>
        <img src={props.dp} />
      </div>

      <div className="beats-controls flex-start">
        <audio
          id={props.src}
          className="audio"
          loop
          onTimeUpdate={(e) => {
            const tag = e.target;
            tag.nextElementSibling.children[0].innerHTML =
              (tag.duration / 60).toFixed(1) + "min";
            const show = tag.nextElementSibling.children[1];
            const bar =
              tag.parentElement.previousElementSibling.children[0].children[0];
            const played = tag.currentTime.toFixed(2);
            const duration = tag.duration.toFixed(2);
            const per = ((played / duration) * 100).toFixed(0);
            show.innerHTML = per + "%";
            bar.style.height = `${per}%`;
          }}
          src={props.src}
        ></audio>

        <div className="box">
          <span className="beats-min"></span>
          <span className="beats-percent"></span>
        </div>

        <div className="beats-action ">
          <div className="like-beats flex-start">
            <span
              className="material-icons"
              style={{ color: likeColor }}
              onClick={(e) => {
				  
                const ref = firestore.doc(
                  `users/${props.phone}/audios/${props.id}`
                );
                const refBucket = firestore.doc(
                  `users/${props.phone}/bucket/${props.id}`
                );
                const inAllPosts = firestore.doc(
                  `users/${myPhone}/bucket/${props.id}`
                );

                const posterRef = firestore.doc(`users/${props.phone}`);
                const array = [];

                posterRef.get().then((snap) => {
                  const followers = snap.data().followers;
                  array.push(...followers);
                });

                ref.get().then((snap) => {
                  const likes = snap.data().likes;

                  if (likes.indexOf(myPhone) === -1) {
                    ref.update({
                      likes: firebase.firestore.FieldValue.arrayUnion(myPhone),
                    });
					refBucket.update({
                      likes: firebase.firestore.FieldValue.arrayUnion(myPhone),
                    });
                    inAllPosts.update({
                      likes: firebase.firestore.FieldValue.arrayUnion(myPhone),
                    });

                    //add like to all the buckets that have the post
                    array.forEach((n) => {
                      const postRef = firestore.doc(
                        `users/${n}/bucket/${snap.id}`
                      );
                      postRef
                        .update({
                          likes:
                            firebase.firestore.FieldValue.arrayUnion(myPhone),
                        })
                        .catch(Error);
                    });

                    e.target.style.color = "crimson";
                  } else {
                    ref.update({
                      likes: firebase.firestore.FieldValue.arrayRemove(myPhone),
                    });
					ref.update({
                      likes: firebase.firestore.FieldValue.arrayRemove(myPhone),
                    });
                    inAllPosts.update({
                      likes: firebase.firestore.FieldValue.arrayRemove(myPhone),
                    });

                    array.forEach((n) => {
                      const postRef = firestore.doc(
                        `users/${n}/bucket/${snap.id}`
                      );
                      postRef
                        .update({
                          likes:
                            firebase.firestore.FieldValue.arrayRemove(myPhone),
                        })
                        .catch(Error);
                    });

                    e.target.style.color = "lavender";
                  }
                  ref.onSnapshot((snap) => {
                    e.target.nextElementSibling.innerHTML =
                      snap.data().likes.length;
                  });
                });
              }}
            >
              favorite
            </span>

            <span>{props.likes.length}</span>
          </div>

          {props.phone === myPhone && (
            <span
              className="beats-delete material-icons"
              onClick={(e) => {
                const firestoreRef = firestore.doc(
                  `users/${props.phone}/audios/${props.id}`
                );
                const storageRef = storage.ref(
                  `users/${props.phone}/audios/${props.id}`
                );
                const confirm = prompt('Type "yes" to delete');

                if (confirm === "yes") {
                  firestoreRef.delete();
                  storageRef.delete();
                  alert("Deleted Successfully");
                } else {
                  alert("Not Deleted");
                }
              }}
            >
              delete
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default Beatscont;
